import React from 'react';
import PageTitleNew from 'components/ui/PageTitleNew';

import { useNavigate } from 'react-router-dom';

import routes from 'app/routes';
import Form from '../Form/Index';

import actions from '../../Actions';

export default function Index() {
  const navigate = useNavigate();

  const onSave = (values) => {
    actions.create(values, () => {
      navigate(routes.admin.report_templates.index);
    }, () => {
      alert('error');
    });
  };

  return (
    <div className="wrapper_assestment invite_wrapper">
      <PageTitleNew title="New Report" />

      <Form onSave={onSave} data={null} />
    </div>

  );
}
